import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import 'moment/locale/de';

import muiTheme from './styles/theme.js';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

moment.locale('de');

import { Provider } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import { store, history } from './store';
import CoreLayout from './layouts/CoreLayout/CoreLayout';

import * as S from './routes/screens';

const RouteSecured = ({ render, ...rest }) => {
    const token = localStorage.getItem('scantouch_token');
    var searchParams = new URLSearchParams(window.location.search);
    const isAuth = (searchParams.has('invitation_token') === true || null !== token);

    return (
        <Route {...rest} render={props => isAuth ? render(props) : <Redirect to="/login" />} />
    );
};

const render = () =>
    ReactDOM.render(
        <MuiThemeProvider muiTheme={muiTheme}>
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <CoreLayout>
                        <Switch>
                            <RouteSecured exact path="/" render={props => <Redirect to="/receipts" />} />

                            <Route exact path="/login" render={props => <S.LoginContainer {...props} />} />
                            <Route exact path="/registration" render={props => <S.RegistrationContainer {...props} />} />
                            <Route exact path="/reset_password" render={props => <S.ResetPasswordContainer {...props} />} />

                            <RouteSecured exact path="/logout" render={props => <S.LogoutContainer {...props} />} />

                            <RouteSecured exact path="/account" render={props => <S.AccountContainer {...props} />} />

                            <RouteSecured exact path="/branches" render={props => <S.BranchesContainer {...props} />} />
                            <RouteSecured exact path="/branches/add" render={props => <S.AddBranchView {...props} />} />
                            <RouteSecured exact path="/branches/:branch_id/upload" render={props => <S.UploadArticlesView {...props} />} />
                            <RouteSecured exact path="/branches/:branch_id/delete" render={props => <S.DeleteBranchView {...props} />} />
                            <RouteSecured exact path="/branches/upload" render={props => <S.UploadToMultipleBranchesView {...props} />} />

                            <RouteSecured exact path="/device_guidelines" render={props => <S.DeviceGuidelinesContainer {...props} />} />

                            <RouteSecured path="/accept_invitation" render={props => <S.AcceptInvitationContainer {...props} />} />

                            <RouteSecured exact path="/settings/data_format" render={props => <S.DataFormatSettingsContainer {...props} />} />
                            <RouteSecured exact path="/settings/customer_orders" render={props => <S.CustomerOrdersContainer {...props} />} />

                            <RouteSecured exact path="/receipts" render={props => <S.ReceiptsContainer {...props} />} />
                            <RouteSecured exact path="/receipts/:id" render={props => <S.ReceiptContainer {...props} />} />

                            <RouteSecured exact path="/subscriptions/list" render={props => <S.SubscriptionsListContainer {...props} />} />
                            <RouteSecured exact path="/subscriptions/new" render={props => <S.SubscriptionsNewContainer {...props} />} />
                            <RouteSecured exact path="/subscriptions/success" render={props => <S.SubscriptionSuccessContainer {...props} />} />

                            <Route render={() => <div>404</div>} />
                        </Switch>
                    </CoreLayout>
                </ConnectedRouter>
            </Provider>
        </MuiThemeProvider>,
        document.getElementById('root')
    );

window.downloadFile = function(sUrl) {
    //iOS devices do not support downloading. We have to inform user about this.
    if (/(iP)/g.test(navigator.userAgent)) {
        alert(
            'Your device does not support files downloading. Please try again in desktop browser.'
        );
        return false;
    }

    //If in Chrome or Safari - download via virtual link click
    if (window.downloadFile.isChrome || window.downloadFile.isSafari) {
        //Creating new link node.
        var link = document.createElement('a');
        link.href = sUrl;

        if (link.download !== undefined) {
            //Set HTML5 download attribute. This will prevent file from opening if supported.
            var fileName = sUrl.substring(sUrl.lastIndexOf('/') + 1, sUrl.length);
            link.download = fileName;
        }

        //Dispatching click event.
        if (document.createEvent) {
            var e = document.createEvent('MouseEvents');
            e.initEvent('click', true, true);
            link.dispatchEvent(e);
            return true;
        }
    }

    // Force file download (whether supported by server).
    if (sUrl.indexOf('?') === -1) {
        sUrl += '?download';
    }

    window.open(sUrl, '_self');
    return true;
};

window.downloadFile.isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
window.downloadFile.isSafari = navigator.userAgent.toLowerCase().indexOf('safari') > -1;

render();

